import { AddressTypes } from "../enums/data.enums";
import { PropertyModel } from "../models/data/property.model";
import { CommonChecks } from "./common-checks.utilities";

export class PropertyUtilities {

    public static getPropertyLabel(propertyModel: PropertyModel): string {

        if (CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(propertyModel.title) == false) {
            return propertyModel.title!;
        }

        const propertyAddress = propertyModel.addresses?.find(a => a.addressType === AddressTypes.Physical);
        if (propertyAddress && CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(propertyAddress.primaryAddress) == false) {
            return propertyAddress.primaryAddress!;
        }

        if (CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(propertyModel.lotNumber) == false) {
            return propertyModel.lotNumber!;
        }

        return "";
    }

}